var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48.0001 41.9748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.9876 28.8494V13.9197L42.1751 14.8572V28.8494C40.4262 29.4382 39.1627 31.0924 39.1627 33.0373V40.5685C39.1627 41.3451 39.7923 41.9748 40.5689 41.9748H46.5938C47.3705 41.9748 48.0001 41.3451 48.0001 40.5685V33.0373C48.0001 31.0924 46.7365 29.4382 44.9876 28.8494ZM22.6665 20.4709L9.03759 15.928V25.5061C9.0376 25.6908 9.07398 25.8736 9.14466 26.0442C9.21534 26.2149 9.31893 26.3699 9.44953 26.5005C13.3366 30.3871 18.5044 32.5276 24.0007 32.5276C29.4972 32.5276 34.6645 30.3871 38.5507 26.5003C38.8144 26.2366 38.9626 25.879 38.9626 25.5061V15.928L25.3342 20.4708C24.4683 20.7594 23.5323 20.7594 22.6665 20.4709Z",
    fill: "var(--fill-0, #B70707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0001 17.8748C24.1503 17.8748 24.3005 17.8507 24.4447 17.8026L47.0385 10.2714C47.3185 10.1781 47.562 9.999 47.7346 9.75957C47.9071 9.52014 48 9.23249 48 8.93735C48 8.64222 47.9071 8.35456 47.7346 8.11513C47.562 7.8757 47.3185 7.69663 47.0385 7.60329L24.4447 0.0720701C24.1561 -0.0240234 23.8441 -0.0240234 23.5554 0.0720701L0.961687 7.60329C0.681657 7.69659 0.438086 7.87564 0.265484 8.11507C0.0928811 8.35451 0 8.64219 0 8.93735C0 9.23251 0.0928811 9.52019 0.265484 9.75963C0.438086 9.99906 0.681657 10.1781 0.961687 10.2714L23.5554 17.8026C23.6997 17.8507 23.8499 17.8748 24.0001 17.8748Z",
    fill: "var(--fill-0, #B70707)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill1);
export default __webpack_public_path__ + "static/media/skill-1.4256d14a73048438edbe5c6345bfcf69.svg";
export { ForwardRef as ReactComponent };